import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Accordion as AccordionWrapper, AccordionItem } from "react-sanfona";
import { ReactComponent as Chevron } from "assets/svg/chevronRight.svg";

const Wrapper = styled.div`
  .react-sanfona {
  }
  .react-sanfona-item {
    &:not(:last-child) {
      margin-bottom: ${({ theme }) => theme.spacer}px;
    }
    .labelWrapper {
      ${({ theme }) => theme.resFontSize.medium};
      font-weight: bold;

      cursor: pointer;

      align-items: center;
      color: ${({ theme }) => theme.palette.primary};
      background-color: ${({ theme }) => theme.palette.blue.lighter};
      border-radius: ${({ theme }) => theme.radius.small}px;
      display: flex;
      justify-content: space-between;
      padding: ${({ theme }) => theme.spacer * 1.3}px
        ${({ theme }) => theme.spacer * 2}px;

      > svg {
        @media print {
          display:none;
        }
        height: 1.2rem;
        transform-origin: 50%;
        transition: transform cubic-bezier(0.54, 0.23, 0, 1.75) 0.6s;
        transform: rotate(90deg);
      }
    }

    &.react-sanfona-item-expanded {
      .labelWrapper {
        > svg {
          transform: rotate(-90deg);
        }
      }
    }

    .react-sanfona-item-body-wrapper {
        @media print {
          padding:0px;
        }
      padding: 0 ${({ theme }) => theme.spacer * 3}px;
      > *:not(:last-child) {
        border-bottom: 1px solid;
      }
    }
  }

  @media print {
    div.react-sanfona-item-body {
      overflow: visible !important;
      max-height: none !important;
    }
  }
`;

const Label = (label) => (
  <div className="labelWrapper">
    {label}
    <Chevron />
  </div>
);

const Accordion = ({ className, list, allowMultiple }) => {
  const classes = ["Accordion"];
  if (className) classes.push(className);

  return (
    <Wrapper className={classes.join(" ")}>
      <AccordionWrapper allowMultiple={allowMultiple}>
        {list.map((l) => (
          <AccordionItem expanded={l.expanded} key={l.label} title={Label(l.label)}>
            {l.accordionContent}
          </AccordionItem>
        ))}
      </AccordionWrapper>
    </Wrapper>
  );
};

Accordion.displayName = "Accordion";

Accordion.propTypes = {
  className: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      accordionContent: PropTypes.node,
    })
  ),
  allowMultiple: PropTypes.bool,
};

Accordion.defaultProps = {
  className: null,
  list: [],
  allowMultiple: false,
};

export default Accordion;
